/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const FullScreenLeaveSmallIcon = ({ width = 12, height = 12, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 12 12' fill={color} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3.5C12 3.77614 11.7761 4 11.5 4L8.7 4C8.3134 4 8 3.6866 8 3.3V0.5C8 0.223858 8.22386 2.07506e-07 8.5 2.19636e-07C8.77614 2.31766e-07 9 0.223858 9 0.5V2.8C9 2.91046 9.08954 3 9.2 3H11.5C11.7761 3 12 3.22386 12 3.5Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 8.5C12 8.22386 11.7761 8 11.5 8H8.7C8.3134 8 8 8.3134 8 8.7V11.5C8 11.7761 8.22386 12 8.5 12C8.77614 12 9 11.7761 9 11.5V9.2C9 9.08954 9.08954 9 9.2 9H11.5C11.7761 9 12 8.77614 12 8.5Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.17475e-07 3.5C2.05464e-07 3.77614 0.223858 4 0.5 4L3.3 4C3.6866 4 4 3.6866 4 3.3L4 0.5C4 0.223858 3.77614 1.21302e-08 3.5 0C3.22386 -1.21302e-08 3 0.223858 3 0.5V2.8C3 2.91046 2.91046 3 2.8 3L0.5 3C0.223858 3 2.29486e-07 3.22386 2.17475e-07 3.5Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 8.5C1.20108e-08 8.22386 0.223858 8 0.5 8H3.3C3.6866 8 4 8.3134 4 8.7L4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5L3 9.2C3 9.08954 2.91046 9 2.8 9H0.5C0.223858 9 -1.20108e-08 8.77614 0 8.5Z'
    />
  </svg>
);

export default FullScreenLeaveSmallIcon;
